export default __webpack_public_path__ + "static/media/sharepoint5.5efdfe73.png";